export class Field {

  constructor(public id: number,
              public scope: string,
              public kit_id: number,
              public element_id: number,
              public label: string,
              public engine_id: string,
              public value: string,
              public type: string,
              public ord: number,
              public sub_label: string,
              public options: string,
              public placeholder: string,
              public required: number,
              public limit: number,
              public max_length: number,
              public hidden: number,
              public updated_at: string,
              public created_at: string,
  ) {}
}

export interface IRawField {
  id: number;
  scope: string;
  kit_id: number;
  element_id: number;
  label: string;
  engine_id: string;
  value: string;
  type: string;
  ord: number;
  sub_label: string;
  options: string;
  placeholder: string;
  required: number;
  limit: number;
  max_length: number;
  hidden: number;
  updated_at: string;
  created_at: string;
}

export function mapField(object: any): Field {
  return new Field(
    object.id,
    object.scope,
    object.kit_id,
    object.element_id,
    object.label,
    object.engine_id,
    object.value,
    object.type,
    object.ord,
    object.sub_label,
    object.options,
    object.placeholder,
    object.required,
    object.limit,
    object.max_length,
    object.hidden,
    object.updated_at,
    object.created_at,
  );
}



// WEBPACK FOOTER //
// ./src/app/services/field.ts